import VectorSource, {Options}  from 'ol/source/Vector';
import LineString from 'ol/geom/LineString';
import TrackLineFeature from './TrackLineFeature';
import _ from 'lodash';
import { TrackEntity } from './TrackEntity';

export default class LineFeatureSource extends VectorSource<LineString> {
    track: TrackEntity
    maxOrder = 0

    constructor(track: TrackEntity, options: Options) {
        super(options)
        this.track = track
    }
    getFeatures() {
        return _.sortBy(super.getFeatures().map(f => f as TrackLineFeature), f => f.order)
    }
    addFeature(feature: TrackLineFeature) {
        super.addFeature(feature)
        if(feature.order > this.maxOrder) {
            this.maxOrder = feature.order
        }

        feature.setStyle(this.track.GetStyle())
    }
    addFeatures(features: TrackLineFeature[]) {
        super.addFeatures(features)
        const maxOrderOfNew = _.max(features.map(f => f.order)) || 0
        if(maxOrderOfNew > this.maxOrder) {
            this.maxOrder = maxOrderOfNew
        }
        features.forEach(f => f.setStyle(this.track.GetStyle()))
    }
}